import GlobalCTA from "../components/GlobalCTA";
import BlogHero from "./BlogHero";
import BlogList from "./BlogList";
import BlogTopics from "./BlogTopics";

export default function Blogs() {
  return (
    <>
      {/* <Seo
        title="Blogs | Oglitz Software"
        description="Insights, articles, and expert opinions on software development, cloud, DevOps, and digital transformation."
        path="/blogs"
      /> */}

      <BlogHero />
      <BlogTopics />
      {/* <BlogList /> */}

      <GlobalCTA
        title="Need Expert"
        highlight="Guidance?"
        subtitle="Let our experts help you design, build, and scale digital products."
      />
    </>
  );
}
